/** 与 main-app `medalPendingPull` 约定的事件名（子应用触发、主应用拉取） */
export const MEDAL_PENDING_PULL_EVENT = "eweadn:medal-pending-pull";

export function emitMedalPendingPullRequest(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(MEDAL_PENDING_PULL_EVENT));
}

/** 用户操作后请求主应用拉取勋章通知（键鼠子应用 / 社区共用） */
export function scheduleMedalPendingPull(): void {
  emitMedalPendingPullRequest();
}
